import React, { Component } from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { isFunction as _isFunction, get as _get } from 'lodash';
import PropTypes from 'prop-types';

import { QuickActionMenu } from '@vfgroup-oneplatform/foundation/Components';
import SpinnerOverlay from '@vfgroup-oneplatform/foundation/Components/SpinnerOverlay';
import { LottieTypes } from '@vfgroup-oneplatform/foundation/Components/VFLottieView';

import StepperView from '../../../CommonUI/StepperView';
import CostBreakDown from '../../Components/CostBreakDown';
import UpgradeDeviceSuccessModal from '../../Components/UpgradeDeviceSuccessModal';
import DeviceDetails from '../DeviceDetails';
import DevicesSelection from '../DevicesSelection';
import PlanSelection from '../PlanSelection';
import Summary from '../Summary';

import styles from './PurchaseSteps.Styles';

const steps = [
  {
    i18nKey: 'device_upgrade_choose_step_title',
  },
  {
    i18nKey: 'device_upgrade_device_step_title',
  },
  {
    i18nKey: 'device_upgrade_plan_step_title',
  },
  {
    i18nKey: 'device_upgrade_summary_step_title',
  },
];

const PURCHASE_STEPS_KEYS = Object.freeze({
  DEVICES: 'devices',
  DEVICE_DETAILS: 'device_details',
  PLAN: 'plan',
  SUMMARY: 'summary',
});

class PurchaseSteps extends Component {
  state = {
    activeStep: 0,
    selectedDevice: undefined,
    selectedPlan: undefined,
    isConfirmUpgradeDeviceSuccess: false,
    deliveryOptions: [],
    selectedCapacityIndex: -1,
    selectedColorIndex: -1,
    isEditMode: false,
  };

  componentDidMount() {
    this.onActiveStepIndexChange(PURCHASE_STEPS_KEYS.DEVICES);
  }

  componentDidUpdate(prevProps, prevState) {
    const { activeStep } = this.state;
    if (prevState.activeStep !== activeStep) {
      this.props.setHeader({
        isVisible: activeStep > 0,
        isCostBreakDownButtonVisible: activeStep === 1 || activeStep === 2,
      });
    }
  }

  onActiveStepIndexChange = stepKey => {
    const { onActiveStepIndexChange: _onActiveStepIndexChange } = this.props;
    const { activeStep: _, ...userSelections } = this.state;

    _onActiveStepIndexChange(stepKey, userSelections);
  };

  onSelectDevicePress = device => {
    const { isEditMode, selectedDevice } = this.state;
    if (isEditMode && device?.id !== selectedDevice?.id) {
      this.resetEditMode(0);
    }
    this.setState(
      {
        activeStep: 1,
        selectedDevice: {
          ...device,
          price: {
            ...device.price,
            recurringChargeBase: device.price.recurringCharge,
          },
        },
      },
      () => {
        this.onActiveStepIndexChange(PURCHASE_STEPS_KEYS.DEVICE_DETAILS);
        this.props.setHeader({
          selectedDevice: device,
        });
      },
    );
  };

  onConfirmDevicePress = deliveryOptions => {
    this.setState({ activeStep: 2, deliveryOptions }, () => {
      this.onActiveStepIndexChange(PURCHASE_STEPS_KEYS.PLAN);
      this.resetStachedData();
    });
  };

  onSelectPlanPress = plan => {
    this.setState({ activeStep: 3, selectedPlan: plan }, () => {
      this.onActiveStepIndexChange(PURCHASE_STEPS_KEYS.SUMMARY);
      this.props.setHeader({
        selectedPlan: plan,
      });
    });
  };

  onConfirmUpgradeDevicePress = (
    selectedPaymentMehtod,
    selectedDeliveryType,
    selectedDeliveryAddress,
  ) => {
    const { confirmUpgradeDevice } = this.props;
    const { selectedDevice, selectedPlan } = this.state;
    if (_isFunction(confirmUpgradeDevice)) {
      confirmUpgradeDevice(
        selectedDevice,
        selectedPlan,
        selectedPaymentMehtod,
        selectedDeliveryType,
        selectedDeliveryAddress,
      );
    }
  };
  onCofirmUpgradeDeviceLoadingFinish = () => {
    const { isConfirmUpgradeDeviceFailed } = this.props;
    if (!isConfirmUpgradeDeviceFailed) {
      this.setState({ isConfirmUpgradeDeviceSuccess: true });
    }
  };

  onConfirmPurchasePress = () => {};
  onColorChange = index => {
    const { deviceDetails } = this.props;
    const color = deviceDetails?.colors[index];
    const { isEditMode, selectedColorIndex, selectedCapacityIndex } = this.state;

    if (isEditMode) {
      if (selectedColorIndex !== index) {
        this.resetEditMode(1);
      }
    } else if (
      this.isSameAsStached({
        colorIndex: index,
        capacityIndex: selectedCapacityIndex,
      })
    ) {
      this.restorEditMode();
    }
    this.setState(state => ({
      selectedDevice: { ...state.selectedDevice, color: color.name },
      selectedColorIndex: index,
    }));
    this.props.setHeader({
      color,
    });
  };
  onCapacityChange = index => {
    const { deviceDetails } = this.props;
    const capacity = deviceDetails?.capacity[index];
    const { isEditMode, selectedCapacityIndex, selectedColorIndex } = this.state;

    if (isEditMode) {
      if (selectedCapacityIndex !== index) {
        this.resetEditMode(1);
      }
    } else if (
      this.isSameAsStached({
        colorIndex: selectedColorIndex,
        capacityIndex: index,
      })
    ) {
      this.restorEditMode();
    }

    this.setState(state => {
      const updatedSelectedDevice = {
        ...state.selectedDevice,
        price: {
          ...state.selectedDevice.price,
          recurringCharge:
            state.selectedDevice.price.recurringChargeBase + capacity.priceMonthlyIncrease.value,
        },
        capacity: capacity.value,
      };
      this.props.setHeader({
        selectedDevice: updatedSelectedDevice,
      });
      return {
        ...state,
        selectedDevice: updatedSelectedDevice,
        selectedCapacityIndex: index,
      };
    });
  };

  onStepPress = index => {
    const { activeStep, isEditMode } = this.state;
    if (isEditMode) {
      // in Edit mode
      this.setState({
        activeStep: index,
      });
    } else {
      // in default mode
      if (index < activeStep) {
        this.setState({
          activeStep: index,
        });
        this.resetStepsData(index);
      }
    }
  };
  onEditSelectionPress = () => {
    this.setState({
      activeStep: 0,
      isEditMode: true,
    });
  };

  // stached values for Edit Mode
  stachedSelectedPlan = undefined;
  stachedSelectedCapacityIndex = undefined;
  stachedSelectedColorIndex = undefined;

  resetEditMode = index => {
    this.setState({
      isEditMode: false,
    });
    this.resetStepsData(index);
  };

  restorEditMode = () => {
    this.setState({
      isEditMode: true,
      selectedPlan: this.stachedSelectedPlan,
    });
  };

  stachEditModeData = () => {
    const { selectedColorIndex, selectedCapacityIndex, selectedPlan } = this.state;
    this.stachedSelectedPlan = selectedPlan;
    this.stachedSelectedCapacityIndex = selectedCapacityIndex;
    this.stachedSelectedColorIndex = selectedColorIndex;
  };

  resetStachedData = () => {
    this.stachedSelectedPlan = undefined;
    this.stachedSelectedCapacityIndex = undefined;
    this.stachedSelectedColorIndex = undefined;
  };

  isSameAsStached = ({ colorIndex, capacityIndex }) => {
    return (
      this.stachedSelectedColorIndex === colorIndex &&
      this.stachedSelectedCapacityIndex === capacityIndex
    );
  };

  resetStepsData = index => {
    switch (index) {
      case 0:
        this.setState({
          selectedDevice: undefined,
          selectedPlan: undefined,
          selectedCapacityIndex: -1,
          selectedColorIndex: -1,
        });
        this.resetStachedData();
        this.props.resetHeader();

        break;
      case 1:
        // keep previous data stached when Edit-Mode canceled
        this.stachEditModeData();
      case 2:
        this.props.setHeader({
          selectedPlan: undefined,
        });
        this.setState({
          selectedPlan: undefined,
        });
        break;
    }
  };

  renderCostBreakDownModal = () => {
    const { isCostBreakDownModalVisible, onCloseCostBreakDownModal, renderCostBreakDownFooter } =
      this.props;
    const { selectedPlan, selectedDevice } = this.state;
    const currency = _get(selectedDevice, 'price.currency', '');
    const recurringChargePeriodDuration = _get(
      selectedDevice,
      'price.recurringChargePeriodDuration',
      0,
    );
    return (
      <QuickActionMenu
        isVisible={isCostBreakDownModalVisible}
        toggleModal={onCloseCostBreakDownModal}
        closeModal={onCloseCostBreakDownModal}
        title={'device_upgrade_cost_breakdown_modal_title'}
        type="secondary"
        titleStyle={styles.title}
        headerStyle={styles.header}
        containerStyle={styles.QAMContainerStyle}
      >
        <CostBreakDown
          planImage={selectedDevice?.image}
          recurringChargePeriodDuration={recurringChargePeriodDuration}
          currency={currency}
          selectedPlan={selectedPlan}
          selectedDevice={selectedDevice}
          renderCostBreakDownFooter={renderCostBreakDownFooter}
        />
      </QuickActionMenu>
    );
  };

  render() {
    const {
      activeStep,
      isConfirmUpgradeDeviceSuccess,
      selectedPlan,
      deliveryOptions,
      selectedDevice,
      selectedCapacityIndex,
      selectedColorIndex,
      isEditMode,
    } = this.state;
    const {
      paymentMethods,
      deliveryAddresses,
      isPaymentMethodsLoading,
      isDeliveryAddressesLoading,
      isConfirmUpgradeDeviceLoading,
      deliveryDate,
      onTermsAndConditionsPress,
      onReturnPolicyPress,
      onDeviceUpgradeSuccessActionPress,
      firstBill,
      userName,
      startDate,
      isDevicesLoading,
      devices,
      plans,
      currentPlan,
      isPlansLoading,
      deviceDetails,
      isDeviceDetailLoading,
      onDeviceOverviewPress,
      onDeviceFullSpecsPress,
      stepperViewStyle,
      isCurrencyFirst,
    } = this.props;
    return (
      <View style={styles.containerStyle}>
        <StepperView
          onStepPress={this.onStepPress}
          steps={steps}
          activeStep={activeStep}
          style={stepperViewStyle}
          isEditMode={isEditMode}
        />
        {activeStep === 0 && (
          <DevicesSelection
            isLoading={isDevicesLoading}
            devices={devices}
            onSelectDevicePress={this.onSelectDevicePress}
            isEditMode={isEditMode}
            selectedDevice={selectedDevice}
          />
        )}
        {activeStep === 1 && (
          <DeviceDetails
            isEditMode={isEditMode}
            selectColorTypeOption={this.onColorChange}
            selectCapacityTypeOption={this.onCapacityChange}
            onConfirmPress={this.onConfirmDevicePress}
            deviceDetails={deviceDetails}
            isDeviceDetailLoading={isDeviceDetailLoading}
            selectedColorIndex={selectedColorIndex}
            selectedCapacityIndex={selectedCapacityIndex}
            onDeviceOverviewPress={() => onDeviceOverviewPress(selectedDevice)}
            onDeviceFullSpecsPress={onDeviceFullSpecsPress}
          />
        )}
        {activeStep === 2 && (
          <PlanSelection
            title={'device_upgrade_plan_screen_title'}
            onSelectPlanPress={this.onSelectPlanPress}
            isLoading={isPlansLoading}
            plans={plans}
            currentPlan={currentPlan}
            isEditMode={isEditMode}
            selectedPlan={selectedPlan}
            isCurrencyFirst={isCurrencyFirst}
          />
        )}
        {activeStep === 3 && (
          <Summary
            {...this.state}
            paymentMethods={paymentMethods}
            deliveryOptions={deliveryOptions}
            deliveryAddresses={deliveryAddresses}
            isPaymentMethodsLoading={isPaymentMethodsLoading}
            isDeliveryAddressesLoading={isDeliveryAddressesLoading}
            onConfirmPress={this.onConfirmUpgradeDevicePress}
            onTermsAndConditionsPress={onTermsAndConditionsPress}
            onReturnPolicyPress={onReturnPolicyPress}
            onEditSelectionPress={this.onEditSelectionPress}
            firstBill={firstBill}
            startDate={startDate}
          />
        )}

        <SpinnerOverlay
          isVisible={isConfirmUpgradeDeviceLoading}
          autoPlay
          loop
          lottieStyle={styles.overlayLottie}
          onModalHide={this.onCofirmUpgradeDeviceLoadingFinish}
          type={LottieTypes.whiteSpinner}
        />

        <UpgradeDeviceSuccessModal
          isVisible={isConfirmUpgradeDeviceSuccess}
          selectedPlanName={selectedPlan?.name}
          selectedDeviceName={selectedDevice?.name}
          deliveryDate={deliveryDate}
          userName={userName}
          onDeviceUpgradeSuccessActionPress={onDeviceUpgradeSuccessActionPress}
        />
        {this.renderCostBreakDownModal()}
      </View>
    );
  }
}

PurchaseSteps.defaultProps = {
  onActiveStepIndexChange: () => {},
  onDeviceOverviewPress: () => {},
  onDeviceFullSpecsPress: () => {},
};

PurchaseSteps.propTypes = {
  setHeader: PropTypes.func,
  onActiveStepIndexChange: PropTypes.func,
  isDevicesLoading: PropTypes.bool,
  isCostBreakDownModalVisible: PropTypes.bool,
  closeCostBreakDownModal: PropTypes.func,
  plans: PropTypes.array,
  currentPlan: PropTypes.object,
  isPlansLoading: PropTypes.bool,
  devices: PropTypes.arrayOf(
    PropTypes.shape({
      brand: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      image: PropTypes.shape({ uri: PropTypes.string.isRequired }).isRequired,
      price: PropTypes.shape({
        upfront: PropTypes.number,
        currency: PropTypes.string,
        recurringCharge: PropTypes.number,
      }).isRequired,
      isRecommended: PropTypes.bool,
    }),
  ),
  onCloseCostBreakDownModal: PropTypes.func,
  confirmUpgradeDevice: PropTypes.func,
  isConfirmUpgradeDeviceFailed: PropTypes.bool,
  paymentMethods: PropTypes.array,
  deliveryAddresses: PropTypes.array,
  isPaymentMethodsLoading: PropTypes.bool,
  isDeliveryAddressesLoading: PropTypes.bool,
  isConfirmUpgradeDeviceLoading: PropTypes.bool,
  deliveryDate: PropTypes.string,
  onTermsAndConditionsPress: PropTypes.func,
  onReturnPolicyPress: PropTypes.func,
  onDeviceUpgradeSuccessActionPress: PropTypes.func,
  firstBill: PropTypes.string,
  userName: PropTypes.string,
  startDate: PropTypes.string,
  deviceDetails: PropTypes.shape({
    colors: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        code: PropTypes.string.isRequired,
        deviceImageKey: PropTypes.string.isRequired,
      }),
    ),
    capacity: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        priceMonthlyIncrease: PropTypes.shape({
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
          currency: PropTypes.string.isRequired,
          period: PropTypes.string.isRequired,
        }),
      }),
    ),
    specifications: PropTypes.arrayOf(
      PropTypes.shape({
        main: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string.isRequired,
            values: PropTypes.arrayOf(PropTypes.string.isRequired),
            extraFeatures: PropTypes.arrayOf(PropTypes.string.isRequired),
          }),
        ),
        inBox: PropTypes.arrayOf(PropTypes.string.isRequired),
      }),
    ),
    collection: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string.isRequired,
        days: PropTypes.string.isRequired,
        price: PropTypes.string.isRequired,
        icon: PropTypes.object.isRequired,
      }),
    ),
  }),
  isDeviceDetailLoading: PropTypes.bool,
  resetHeader: PropTypes.func,
  onDeviceOverviewPress: PropTypes.func,
  onDeviceFullSpecsPress: PropTypes.func,
  stepperViewStyle: ViewPropTypes.style,
  renderCostBreakDownFooter: PropTypes.func,
  isCurrencyFirst: PropTypes.bool,
};

export { PURCHASE_STEPS_KEYS };
export default PurchaseSteps;
